<template>
    <div>
        <inbox-assign-modal></inbox-assign-modal>         
        <div class="chart-font">
            <div class="row">
                <div class="col title text-muted">Unread Inbound Faxes</div>
            </div>
            <div v-if="documents.length" class="table-responsive">
                <table class="table table-sm">
                    <thead>
                        <th>Document Type</th>
                        <th>Patient</th>
                        <th>Description</th>
                        <th>Client</th>                    
                        <th>Received</th>
                        <th></th>
                    </thead>
                    <tbody>
                        <tr v-for="document in documents" :key="'unread-documents-chart-' + document.id">
                            <td>
                                <a :href="getHref(document)" target="_blank">{{ document.document_type_name }}</a>
                            </td>
                            <td>
                                <a v-if="document.patient_last" :href="getHref(document)" target="_blank" :title="document.patient_last">{{ document.patient_last | truncate(25) }}</a>
                            </td>
                            <td :title="document.description">{{ document.description | truncate(25) }}</td>
                            <td>{{ document.client_name | truncate(25) }}</td>
                            <td>{{ document.receive_time | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                            <td>
                                <a v-if="document.document_type_id == DocumentType.INBOUND_FAX" href="javascript:void(0)" title="Link Document with Claim" @click="assign(document.id, document.client_id)">
                                    <i class="fas fa-link fa-sm"></i>
                                </a>
                                <a v-else :href="'/claims/' + document.claim_id" title="View Claim"><i class="fas fa-folder fa-sm"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="border-top pt-2">
                <h5 class="text-muted text-center">No unread inbound faxes.</h5>
            </div> 
        </div>
    </div>   
</template>

<script>
import { DocumentType } from '../../constants.js';
import InboxAssignModal from '../inbox/InboxAssignComponent.vue';

export default {
    components: {
        InboxAssignModal
    },    
    props: {
        href: String
    },
    data() {
        return {
            documents: [],

            // import constants into the template
            DocumentType: DocumentType,            
        }
    },
    methods: {
        refresh: function () {
            axios.get(this.href)
                .then(response => {
                    this.documents = response.data;
                })
                .catch(error => {
                    console.log(error.response.data);
                });
        },
        assign: function (documentId, clientId) {
            eventHub.$emit('show-inbox-assign', {
                documentId: documentId,
                clientId: clientId,
            });
        },
        getHref: function (document) {
            return (document.document_type_id === DocumentType.INBOUND_FAX) ? 
                ('/inbox/documents/' + document.id) :
                ('/claims/' + document.claim_id + '/documents/' + document.id);
        }
    },
    created() {
        // eventHub.$on('inbox-refresh', this.refresh);
        this.refresh();
    },
    beforeDestroy() {
        // eventHub.$off('inbox-refresh');
    }
}
</script>

<style scoped>
    .chart-font {
        font-size: 12px;
        font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
        font-style: normal;
        font-weight: bold;
        color: #666;
    }
</style>